<template lang="pug">
  div.map-context.map-context-relation.map-marker-actions
    ul
      li(@click.prevent.stop="editRelation()") Редактировать связь
      li(
      v-if="isRemoved"
      @click.prevent.stop="restoreItem()"
      ) Восстановить связь
      li(
      v-else
      @click.prevent.stop="deleteItem()"
      ) Удалить связь
</template>

<script>
  import permissionMixin from '../../../mixins/permission-mixin.js'
  import mapContextMixin from '../mixins/map-context-mixin.js'
  import RelationPopup from '../utils/popup/RelationPopup.js'
  import {map as mapEndpoints, tko} from '../../../api/api-endpoints.js'
  import {POPUP_AUTO_PAN, POPUP_KEEP_IN_VIEW} from '../../../config/map.js'
  import {PERMS} from '../../../config/permissions.js'

  export default {
    name: 'map-context-relation',
    mixins: [mapContextMixin, permissionMixin],
    computed: {
      isRemoved () {
        if (this.model && this.model.end && this.model.end.is_del) {
          return true
        }
        if (this.model && this.model.start && this.model.start.is_del) {
          return true
        }
        return false
      },
      threadId () {
        if (this.model && this.model.end) {
          return this.model.end.thread_id
        }
        return 0
      },
      restoredTkoObject () {
        if (this.model && this.model.end && this.model.end.threads_tko_object_id) {
          return this.model.end
        }
        if (this.model && this.model.start && this.model.start.threads_tko_object_id) {
          return this.model.start
        }
        return null
      }
    },
    methods: {
      restoreItem: async function () {
        this.closeMenu()
        if (!this.threadId) {
          console.error('thread_id not found')
          return false
        }
        try {
          const r = await this.$sharedServices.store.dispatch('updateModel', {
            url: mapEndpoints.threadDeleteRestore(this.threadId)
          })
          if (!this.restoredTkoObject) {
            throw new Error('Связанный объект тко не найден')
          }
          if (this.restoredTkoObject.thread_del) {
            await this.$sharedServices.store.dispatch('updateModel', {
              url: tko.objectDeleteRestore(this.restoredTkoObject.id)
            })
          }
          console.log('this.restoredTkoObject', this.restoredTkoObject)
          this.onSuccess(r)
        } catch (e) {
          this.$e.errorBox(e)
          this.$bar.finish()
        }
        return true
      },
      editRelation () {
        /* if (this.userHavePermissionEx(PERMS.EDIT) === false) {
          return false
        } */

        this.popup = new RelationPopup({
          autoPan: POPUP_AUTO_PAN,
          keepInView: POPUP_KEEP_IN_VIEW,
          minWidth: 700,
          minHeight: 800,
          model: this.model,
          opts: {
            vm: this
          }
        })
        this.closeMenu()
        this.layer.bindPopup(this.popup).openPopup()
      },
      deleteWithRestorePossibility () {
        this.closeMenu()
        if (!this.threadId) {
          console.error('thread_id not found')
          return
        }
        this.$e.confirmBox(
          'Вы сможете восстановить связь',
          'Удалить связь?'
        ).then(() => {
          this.$bar.start()
          console.log(this.model)
          // delete with restore
          this.$sharedServices.store.dispatch('updateModel', {
            url: mapEndpoints.threadDeleteLogic(this.threadId)
          }).then(r => {
            this.onSuccess(r)
          }).catch(erResponse => {
            this.$e.errorBox(erResponse)
            this.$bar.finish()
          })
        })
      },
      onSuccess (r) {
        this.$bar.finish()
        let refreshedSubs = null
        refreshedSubs = this.$emitter.listen('geo.threadsDrawer.refreshed', () => {
          this.$emitter.emit('geo.threadsDrawer.showMarker', {
            obj: this.model.end
          })
          refreshedSubs.unsubscribe()
        })
        // after succes, full map data reload
        this.$emitter.emit('geo.mapUpdate', {
          component: 'map-context-relation',
          action: 'delete',
          response: r
        })
      },
      deleteItem () {
        if (this.userHavePermissionEx(PERMS.DELETE) === false) {
          return false
        }
        this.deleteWithRestorePossibility()
      }
    }
  }
</script>

